/* AG Stealth Black Edition landing page, journey orchestration.

   Cloned from ag-kettlebell-landing.js at journey-v17.32 and renamed into the
   agbe- namespace on purpose: the kettlebell page is LIVE and public, so the
   two pages deliberately share no JS. Everything hard-won carries over intact
   (the WebKit video axioms, seeked-gated scrubbing, the flick/beat blocker,
   glideTo, the guided tour, runtime cutouts, the decks).

   What was dropped: the JPEG frame-sequence engines and their idle prefetch
   queue. This page is video-only from day one, so there is nothing to fall
   back to and no frames to prime.

   What was added: createStill(). Chapters 4+ tell the story in photographs
   rather than film, so a still chapter drives a scroll-linked drift on its
   photo over exactly the same beat as a film. Swapping a still for real
   footage later means removing one attribute in the liquid.

   GSAP ScrollTrigger (self-hosted agkb-gsap.min.js + agkb-scrolltrigger.min.js,
   shared with the kettlebell page since they are untouched vendor bundles)
   drives the hero push-in/dip, caption windows, the sequence bar, header
   state, journey rail and card entrances. If GSAP is missing the fallback
   runs everything from one scroll listener - the page never breaks. */
(function () {
  window.__agbeEngine = 'black-v1.8';
  var root = document.querySelector('.agbe');
  if (!root) return;

  var frameBase = root.dataset.frameBase || '';
  /* ☠ Films MUST come from FILM_URLS, which the liquid builds with `| asset_url`
     so each carries a `?v=` fingerprint that CHANGES when the file changes.
     Building the URL from frameBase instead yields an UNVERSIONED CDN path,
     and Cloudflare caches those for days: a re-encoded film (same filename) is
     then silently INERT live while the old bytes keep serving. This bit the
     kettlebell page and it bit agbev-inuse.mp4 here (luke row served in place
     of the graded press for ~4 days). frameBase is the fallback only. */
  var FILM_URLS = {};
  try { FILM_URLS = JSON.parse(root.dataset.filmUrls || '{}'); } catch (eFU) { FILM_URLS = {}; }
  /* The whole journey is driven by ONE geometric point per section:
     coverOf() = the fraction of a section's range where the next section
     begins fading over it. Films complete their motion exactly there;
     captions flip at HALF of it, so each caption owns exactly half the
     film's frames; anchors rest just before the flip and just before the
     cover - which makes every anchor-to-anchor beat identical by
     construction: (H - vh) / 2 of scroll. */
  var clamp = function (v, min, max) { return Math.min(max, Math.max(min, v)); };

  /* Geometry cache: every per-frame callback reads from here instead of
     forcing layout mid-scroll. Refreshed on load, resize and ScrollTrigger
     refresh - one class of micro-hitches removed entirely. */
  var GEO = { vh: window.innerHeight, max: 0, map: {}, byEl: (typeof WeakMap === 'function' ? new WeakMap() : null) };
  /* All layout heights in the CSS are svh (toolbar-stable). innerHeight is
     NOT - iOS grows it ~7% when the toolbar collapses mid-scroll, which
     would stretch every beat anchor under the reader's finger. Measure the
     svh unit itself via a probe so JS geometry equals CSS geometry in every
     toolbar state; browsers without svh fall back to innerHeight. */
  var vhProbe = document.createElement('div');
  vhProbe.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:100svh;visibility:hidden;pointer-events:none;';
  (document.body || document.documentElement).appendChild(vhProbe);
  function geoRefresh() {
    GEO.vh = vhProbe.offsetHeight || window.innerHeight;
    GEO.max = document.documentElement.scrollHeight - GEO.vh;
    ['hero', 'films', 'specs', 'choose', 'fitting', 'closer'].forEach(function (name) {
      var el = root.querySelector('[data-agbe="' + name + '"]');
      if (!el) return;
      var g = {
        top: el.getBoundingClientRect().top + window.pageYOffset,
        height: el.offsetHeight,
        cover: 1 - GEO.vh / el.offsetHeight
      };
      GEO.map[name] = g;
      if (GEO.byEl) GEO.byEl.set(el, g);
    });
  }
  geoRefresh();
  addEventListener('resize', geoRefresh);
  addEventListener('orientationchange', geoRefresh);
  addEventListener('load', geoRefresh);
  setTimeout(geoRefresh, 1500);
  setTimeout(geoRefresh, 4000);



  var filmRegistry = [];
  function createFilmVideo(chapter, baseName, onFrame) {
    var v = document.createElement('video');
    v.muted = true;
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    v.setAttribute('muted', '');
    v.preload = 'auto';
    v.className = 'agbe-film-cover';
    var srcUrl = FILM_URLS[baseName] || (frameBase + 'agbev-' + baseName + '.mp4');
    v.src = srcUrl;
    chapter.appendChild(v);
    /* WKWebView ground rules (sim-proven 07-24): preload='auto' SUSPENDS at
       metadata (zero bytes buffered); a paused seek without data never
       fires 'seeked' and does NOT resume the download; loadeddata/seeked
       can therefore never be trusted as "a frame is on glass". The only
       honest paint signal is requestVideoFrameCallback, and the only
       reliable way to make WebKit actually LOAD is a muted play() (allowed
       without a gesture; Low Power Mode rejects it, so a one-shot touch
       listener in journeyFilm re-primes inside a real gesture).
       The poster img under the video shares its side mask - in the feather
       band the video is semi-transparent and the STARTING FRAME ghosts
       through - so it hides ONLY once a frame has truly been presented. */
    var poster = chapter.querySelector('img.agbe-film-cover');
    var posterHidden = false;
    var canRVFC = typeof v.requestVideoFrameCallback === 'function';
    function hidePoster() {
      if (posterHidden || !poster) return;
      posterHidden = true;
      poster.style.opacity = '0';
    }
    function armPaint() {
      if (!canRVFC) return;
      v.requestVideoFrameCallback(function () { hidePoster(); });
    }
    armPaint();
    var primed = false;
    function prime() {
      if (primed || parked) return;
      primed = true;
      var pp;
      try { pp = v.play(); } catch (ePlay) { primed = false; return; }
      if (pp && pp.then) {
        pp.then(function () {
          setTimeout(function () { if (!parked) v.pause(); }, 80);
        }, function () { primed = false; });
      }
    }
    v.addEventListener('loadeddata', function () {
      if (lastSet < 0 && !seekBusy) {
        seekBusy = true;
        seekAt = performance.now();
        lastSet = 0.001;
        try { v.currentTime = 0.001; } catch (eKick) { seekBusy = false; }
      }
    });
    var target = 0, cur = 0, raf = null, dur = 0, lastSet = -1, parked = false;
    var touring = false;
    var held = false;
    /* Seeks are gated on 'seeked': flooding currentTime aborts the in-flight
       seek before it paints, which forward decode tolerates but BACKWARD
       scrubbing does not - the frame freezes while scrolling up. One seek in
       flight at a time means every issued frame actually renders, in both
       directions. The 300ms watchdog unwedges a seek WebKit drops. */
    var seekBusy = false, seekAt = 0;
    v.addEventListener('loadedmetadata', function () { dur = v.duration || 0; });
    v.addEventListener('seeked', function () {
      if (!canRVFC) hidePoster();
      seekBusy = false;
      if (!raf && dur && !parked && Math.abs(cur * dur - lastSet) > 0.02) {
        raf = requestAnimationFrame(tick);
      }
    });
    function tick() {
      if (touring) { raf = null; return; }
      var d = target - cur;
      if (Math.abs(d) < 0.001) cur = target;
      else cur += d * 0.14;
      if (dur) {
        var now = performance.now();
        if (!seekBusy || now - seekAt > 300) {
          var t = cur * dur;
          if (Math.abs(t - lastSet) > 0.02) {
            seekBusy = true;
            seekAt = now;
            try { v.currentTime = t; } catch (eSeek) { seekBusy = false; }
            lastSet = t;
            if (onFrame) onFrame(cur);
          }
        }
      }
      if (cur === target && (!dur || Math.abs(cur * dur - lastSet) <= 0.02)) raf = null;
      else raf = requestAnimationFrame(tick);
    }
    var self = {
      prefix: 'agbev-' + baseName,
      count: 1,
      url: function () { return srcUrl; },
      lastActive: 0,
      resize: function () {},
      ready: function () { return v.readyState >= 3; },
      duration: function () { return dur; },
      setProgress: function (p) {
        target = clamp(p, 0, 1);
        self.lastActive = performance.now();
        if (touring && dur) {
          if (held) return;
          /* Tour legs PLAY the film - the native pipeline, no seek churn
             (seek-scrubbing lerp stutters at leg start and tail). A small
             playbackRate servo keeps the clock locked to the scroll. */
          var err = target * dur - v.currentTime;
          var rate = 1 + err * 2;
          if (rate < 0.5) rate = 0.5; else if (rate > 2) rate = 2;
          try { v.playbackRate = rate; } catch (eRate) {}
          if (v.paused) { try { v.play(); } catch (ePlayT) {} }
          if (onFrame) onFrame(clamp(dur ? v.currentTime / dur : 0, 0, 1));
          return;
        }
        if (!raf) raf = requestAnimationFrame(tick);
      },
      tourPlay: function () { touring = true; held = false; },
      tourHold: function (hold) {
        if (!touring) return;
        held = hold;
        try { if (hold) v.pause(); else v.play(); } catch (eHold) {}
      },
      tourStop: function () {
        if (!touring) return;
        touring = false;
        held = false;
        try { v.pause(); v.playbackRate = 1; } catch (eStopT) {}
        if (dur) {
          cur = clamp(v.currentTime / dur, 0, 1);
          target = cur;
          lastSet = v.currentTime;
        }
      },
      warm: function () { prime(); },
      prime: prime,
      park: function () {
        if (parked) return;
        parked = true;
        seekBusy = false;
        primed = false;
        if (poster) { poster.style.opacity = ''; posterHidden = false; }
        v.removeAttribute('src');
        v.load();
        dur = 0;
        lastSet = -1;
      },
      unpark: function () {
        if (!parked) return;
        parked = false;
        seekBusy = false;
        primed = false;
        v.src = srcUrl;
        v.load();
        armPaint();
        prime();
      },
      purge: function () {}
    };
    return self;
  }

  /* --- Still chapters ---------------------------------------------------
     After the three films the story is told in photographs. A still chapter
     answers the same interface as a film so journeyFilm() cannot tell them
     apart: it consumes setProgress(0..1) over its own beat and spends it on
     a slow scroll-linked drift (scale plus a little vertical travel) instead
     of on video frames.

     Two rules learned on the kettlebell page apply here too:
     - the transform is written from a rAF, never straight from the scroll
       handler, so a burst of scroll events cannot force a burst of layout,
     - nothing here may throw. journeyFilm drives this from inside a
       rAF-driven onFrame, and an exception there kills the loop silently
       for every chapter, not just this one. */
  var STILL_ZOOM = 0.075;   /* 1.000 -> 1.075 across the chapter */
  var STILL_RISE = 2.2;     /* percent of height it drifts upward */
  function createStill(chapter, onFrame) {
    var art = chapter.querySelector('[data-still-art]') || chapter.querySelector('img');
    var target = 0, cur = 0, raf = null, painted = -1;
    function paint() {
      raf = null;
      var d = target - cur;
      if (Math.abs(d) < 0.0015) cur = target;
      else cur += d * 0.16;
      if (art && Math.abs(cur - painted) > 0.0015) {
        painted = cur;
        var s = 1 + STILL_ZOOM * cur;
        var y = -STILL_RISE * cur;
        art.style.transform = 'translate3d(0,' + y.toFixed(3) + '%,0) scale(' + s.toFixed(4) + ')';
      }
      if (onFrame) onFrame(cur);
      if (cur !== target) raf = requestAnimationFrame(paint);
    }
    var self = {
      prefix: 'still',
      count: 1,
      url: function () { return ''; },
      lastActive: 0,
      resize: function () {},
      /* Never gates the loading cue: a still is ready as soon as its <img>
         is, which the browser already handles. */
      ready: function () { return true; },
      duration: function () { return 0; },
      setProgress: function (p) {
        target = clamp(p, 0, 1);
        self.lastActive = performance.now();
        if (!raf) raf = requestAnimationFrame(paint);
      },
      /* The tour drives stills by scroll alone: there is no clock to servo
         and nothing to play, so the tour hooks are deliberately inert. */
      tourPlay: function () {},
      tourHold: function () {},
      tourStop: function () {},
      warm: function () {},
      prime: function () {},
      park: function () {},
      unpark: function () {},
      purge: function () {}
    };
    filmRegistry.push(self);
    return self;
  }

  /* Idle films release their bitmap windows; a return visit refills from
     the primed HTTP cache in a beat. */
  setInterval(function () {
    var now = performance.now();
    var newest = 0;
    filmRegistry.forEach(function (f) { newest = Math.max(newest, f.lastActive || 0); });
    filmRegistry.forEach(function (f) {
      if (f.purge && f.lastActive && f.lastActive !== newest && now - f.lastActive > 12000) f.purge();
    });
  }, 6000);
  addEventListener('resize', function () {
    filmRegistry.forEach(function (f) { if (f.resize) f.resize(); });
  });


  /* --- The film journey: ONE pinned stage, eight chapters, ONE transition
     type. All geometry derives from GEO.vh, so resize just works:
       entryStart = films.top - vh   (the stage begins covering the hero)
       beat       = 1.9vh            (anchor to anchor, the page's pulse)
       anchor A_k = entryStart + (k+1)*beat        k = 0..7
     Chapter k's film plays [S_k, A_k] in full - S_k sits just after the
     previous chapter's rest-and-fade - then holds its final frame for
     FILM_HOLD px and crossfades out over FILM_FADE px while k+1 fades in.
     The stage is pinned for the entire journey (fixed through the entry,
     sticky after), so nothing on screen ever moves: every transition is
     opacity only, and every scroll line between fades drives motion. --- */
  var FILM_BEAT_VH = 1.9;
  var FILM_HOLD = 64;
  var FILM_FADE = 26;
  /* Entry choreography shares the hero's scrub band (entryStart = 0 with the
     current 200svh hero): copy exits 0.30-0.65, the dip blacks out 0.45-0.75,
     and only THEN does film one rise out of the darkness. Starting the stage
     any earlier cuts over a still-lit hero - the "harsh" handoff. */
  var ENTRY_FADE_A = 0.62, ENTRY_FADE_B = 0.96;
  /* Film one starts scrubbing DURING the tail of the stage fade, not
     after it: tying its start to ENTRY_FADE_B squeezed its 3 seconds
     into 0.94vh of scroll - 1.9x the pace of every other film ("film
     one feels shorter"). From 0.70 it gets 1.2vh and plays its opening
     frames while emerging from the dark. */
  var FILM1_SCRUB_START = 0.70;
  var smoothstep = function (t) { return t * t * (3 - 2 * t); };
  function journeyFilm() {
    var section = root.querySelector('[data-agbe="films"]');
    if (!section) return null;
    var stage = section.querySelector('[data-films-stage]');
    var chapterEls = Array.prototype.slice.call(section.querySelectorAll('[data-chapter]'));
    var stepEls = Array.prototype.slice.call(section.querySelectorAll('.agbe-step'));
    var tag = section.querySelector('[data-filmtag]');
    var barEl = section.querySelector('[data-seq-bar]');
    var bar = barEl ? function (v) { barEl.style.transform = 'scaleY(' + v.toFixed(4) + ')'; } : null;
    var N = chapterEls.length;
    if (!N) return null;
    var progress = chapterEls.map(function () { return 0; });
    var warmed = chapterEls.map(function () { return false; });
    var curChapter = 0;
    var films = chapterEls.map(function (chapter, i) {
      var imgs = Array.prototype.slice.call(chapter.querySelectorAll('[data-chapter-film]'));
      imgs.sort(function (a, b) {
        return (a.classList.contains('agbe-film-backdrop') ? 1 : 0) - (b.classList.contains('agbe-film-backdrop') ? 1 : 0);
      });
      if (!imgs.length) return null;
      var frameCb = function (p) {
        progress[i] = p;
        if (bar && i === curChapter) bar(p);
      };
      /* A chapter is either a film (scrubbed mp4) or a still (scroll-driven
         drift on its photograph). Same beat, same crossfade, same anchors -
         so a still can be swapped for real footage later by changing one
         attribute in the liquid and nothing else. */
      if (chapter.hasAttribute('data-still')) return createStill(chapter, frameCb);
      var baseName = (imgs[0].dataset.chapterFilm || '').replace(/^agbe-/, '').replace(/-$/, '');
      return createFilmVideo(chapter, baseName, frameCb);
    });
    /* Low Power Mode rejects gestureless muted play(), so the films may sit
       unloaded until the first real touch - re-prime every live film inside
       that gesture's context, where play() is always allowed. */
    var gesturePrimed = false;
    function gesturePrime() {
      if (gesturePrimed) return;
      gesturePrimed = true;
      films.forEach(function (f) { if (f && f.prime) f.prime(); });
    }
    window.addEventListener('touchstart', gesturePrime, { once: true, passive: true, capture: true });
    window.addEventListener('pointerdown', gesturePrime, { once: true, passive: true, capture: true });
    function geo() {
      var g = GEO.map.films;
      if (!g) { geoRefresh(); g = GEO.map.films; }
      return { top: g.top, entryStart: g.top - GEO.vh, beat: FILM_BEAT_VH * GEO.vh, vh: GEO.vh };
    }
    function anchors() {
      var G = geo();
      var out = [];
      for (var k = 0; k < N; k += 1) out.push(G.entryStart + (k + 1) * G.beat);
      return out;
    }
    /* The stage is pinned with position:fixed for the ENTIRE journey, not
       just the entry: WebKit builds ship position:sticky regressions in
       very tall containers (films render black while computed style still
       says sticky - measured on iOS 26). CSS sticky remains as the base
       for the self-check fallback only. Modes: 'fixed' through entry and
       journey, 'bottom' (absolute at the section foot) while the data
       sheet curtains over, cleared before the entry. */
    var entryFixedOk = null;
    var stageMode = '';
    function pinStage(mode) {
      if (mode === 'fixed' && entryFixedOk === false) mode = '';
      if (mode === stageMode) return;
      stageMode = mode;
      if (mode === 'fixed') {
        stage.classList.add('agbe-pinned');
        stage.style.position = 'fixed';
        stage.style.top = '0';
        stage.style.left = '0';
        stage.style.width = '100%';
        stage.style.bottom = '';
        if (entryFixedOk === null) {
          entryFixedOk = Math.abs(stage.getBoundingClientRect().top) < 3;
          if (!entryFixedOk) { stageMode = ''; pinStage(''); }
        }
      } else if (mode === 'bottom') {
        stage.classList.remove('agbe-pinned');
        stage.style.position = 'absolute';
        stage.style.top = 'auto';
        stage.style.bottom = '0';
        stage.style.left = '0';
        stage.style.width = '100%';
      } else {
        stage.classList.remove('agbe-pinned');
        stage.style.position = '';
        stage.style.top = '';
        stage.style.bottom = '';
        stage.style.left = '';
        stage.style.width = '';
      }
    }
    /* The rail lights by zone NAME, not by chapter index: films and stills
       share the journey but map onto two rail stops, and the mapping lives on
       each chapter as data-zone so adding a chapter cannot silently shift
       every dot along by one. */
    var railAll = null;
    function setRail(zone) {
      if (!railAll) railAll = Array.prototype.slice.call(root.querySelectorAll('[data-rail]'));
      var link = root.querySelector('[data-rail="' + zone + '"]');
      if (!link || link.classList.contains('is-current')) return;
      railAll.forEach(function (l) {
        l.classList.toggle('is-current', l === link);
        if (l === link) l.setAttribute('aria-current', 'true');
        else l.removeAttribute('aria-current');
      });
    }
    function update() {
      var G = geo();
      var y = window.pageYOffset;
      /* Entry: pinned + the whole stage fades in from the dipped hero */
      var pe = (y - G.entryStart) / G.vh;
      var g = GEO.map.films;
      var pinEnd = g ? g.top + g.height - stage.offsetHeight : Infinity;
      if (y > G.entryStart && y < pinEnd) pinStage('fixed');
      else if (y >= pinEnd) pinStage('bottom');
      else pinStage('');
      if (pe > 0 && pe < 1) {
        var so = smoothstep(clamp((pe - ENTRY_FADE_A) / (ENTRY_FADE_B - ENTRY_FADE_A), 0, 1));
        stage.style.opacity = so.toFixed(3);
      } else if (pe >= 1) {
        if (stage.style.opacity) stage.style.opacity = '';
      } else {
        /* At or above the entry start the stage must NEVER cover the
           hero - at exactly y=0 the old else-branch cleared opacity to 1
           over a pinned stage and swallowed the hero + chapter one. */
        stage.style.opacity = '0';
      }
      /* Chapters: fades first, then film scrub ranges */
      var fadeIn = [];
      for (var k = 0; k < N; k += 1) {
        if (k === 0) { fadeIn.push(1); continue; }
        var prevA = G.entryStart + k * G.beat;
        fadeIn.push(smoothstep(clamp((y - (prevA + FILM_HOLD)) / FILM_FADE, 0, 1)));
      }
      for (var k2 = 0; k2 < N; k2 += 1) {
        var A = G.entryStart + (k2 + 1) * G.beat;
        var fout = k2 === N - 1 ? 1 : 1 - fadeIn[k2 + 1];
        var o = Math.min(fadeIn[k2], fout);
        var chapter = chapterEls[k2];
        var key = o.toFixed(3);
        if (chapter.dataset.o !== key) {
          chapter.dataset.o = key;
          chapter.style.opacity = key;
          chapter.style.visibility = o > 0.001 ? 'visible' : 'hidden';
          chapter.style.pointerEvents = 'none';
        }
        if (films[k2]) {
          /* While a nav glide is driving the page, film seeking and
             un/parking is pure churn - seek spam and play() primes on
             every chapter flown past stutter the glide itself (jittery
             nav clicks). Films stand down and paint on arrival; the
             scrub lerp gives the landing a smooth catch-up. The tour is
             exempt: its films play natively and must keep running. */
          var flying = glideRaf !== null && !tourOn;
          if (!flying) {
            var S = k2 === 0 ? G.entryStart + FILM1_SCRUB_START * G.vh : (A - G.beat) + FILM_HOLD + FILM_FADE;
            var dist = y < S ? S - y : (y > A + FILM_HOLD + FILM_FADE ? y - A : 0);
            if (dist < 0.7 * G.beat) {
              if (films[k2].unpark) films[k2].unpark();
              films[k2].setProgress(clamp((y - S) / (A - S), 0, 1));
            } else if (dist > 1.1 * G.beat && films[k2].park) {
              films[k2].park();
            } else {
              films[k2].setProgress(clamp((y - S) / (A - S), 0, 1));
            }
            if (!warmed[k2] && y > S - 1.5 * G.vh && y < A) { warmed[k2] = true; films[k2].warm(); }
          }
        }
      }
      /* Active chapter: captions, film tag, seq bar, rail zone */
      var idx = 0;
      while (idx < N - 1 && y >= G.entryStart + (idx + 1) * G.beat + FILM_HOLD + FILM_FADE / 2) idx += 1;
      if (idx !== curChapter) {
        curChapter = idx;
        chapterEls.forEach(function (el, i) { el.classList.toggle('is-active', i === idx); });
        stepEls.forEach(function (el, i) { el.classList.toggle('is-active', i === idx); });
        if (tag) tag.textContent = chapterEls[idx].getAttribute('data-tag') || '';

      }
      if (bar) bar(progress[curChapter]);
      if (y > G.entryStart + 0.3 * G.vh && y < G.entryStart + N * G.beat + G.vh) {
        setRail(chapterEls[idx].getAttribute('data-zone') || 'story');
      }
    }
    /* See-more: each caption's link glides to the MIDDLE of the next
       chapter's beat (the film mid-motion); the last one leads to the
       data sheet. */
    var seeBtns = Array.prototype.slice.call(section.querySelectorAll('[data-seemore]'));
    seeBtns.forEach(function (btn, k) {
      btn.addEventListener('click', function () {
        var G = geo();
        var target;
        if (k < N - 1) {
          var Anext = G.entryStart + (k + 2) * G.beat;
          var Snext = (Anext - G.beat) + FILM_HOLD + FILM_FADE;
          target = Snext + 0.5 * (Anext - Snext);
        } else {
          target = GEO.map.specs ? GEO.map.specs.top : window.pageYOffset;
        }
        glideTo(target);
      });
    });
    /* Loading cue: the hero's scroll invitation pulses as LOADING THE FILM
       until the opening film's frames are in the HTTP cache (or a few
       seconds pass), then flips to the real call to scroll. */
    var cue = root.querySelector('[data-scrollcue]');
    if (cue) {
      var cueT0 = performance.now();
      var cueTimer = setInterval(function () {
        if ((films[0] && films[0].ready && films[0].ready()) || performance.now() - cueT0 > 6000) {
          clearInterval(cueTimer);
          cue.classList.remove('is-loading');
          cue.querySelector('span').textContent = 'Scroll to begin';
        }
      }, 300);
    }
    /* --- Guided tour: an auto-scroller through the full journey --------
       Each film leg runs over the video's own duration, so the films play
       at their true speed. Every completed chapter holds for a beat, the
       numbers get a slow pass, and the tour parks on the buying section.
       Any touch, wheel or key press cancels instantly (userInterrupt). */
    var tourOn = false, tourTimer = null, tourBtnEl = null, tourLabel = '';
    var tourPausedF = false, tourCurFilm = null;
    function tourSetPaused(pause) {
      if (!tourOn || tourPausedF === pause) return;
      tourPausedF = pause;
      if (tourBtnEl) tourBtnEl.textContent = pause ? 'Resume' : 'Pause';
      var fcur = tourCurFilm !== null ? films[tourCurFilm] : null;
      if (fcur && fcur.tourHold) fcur.tourHold(pause);
    }
    function tourCancel() {
      if (!tourOn) return;
      tourOn = false;
      tourPausedF = false;
      tourCurFilm = null;
      window.__agbeTourOn = false;
      if (tourTimer) { clearTimeout(tourTimer); tourTimer = null; }
      films.forEach(function (f) { if (f && f.tourStop) f.tourStop(); });
      if (tourBtnEl) tourBtnEl.textContent = tourLabel;
    }
    window.__agbeTourCancel = tourCancel;
    function tourSeg(target, dur, linear, done) {
      var from = window.pageYOffset;
      var dist = target - from;
      if (!dist) { done(); return; }
      glideDirSign = dist > 0 ? 1 : -1;
      /* Accumulated clock with a capped step: a main-thread stall (image
         work, decode hitch) PAUSES the tour instead of fast-forwarding it
         - the freeze-then-jump failure mode. */
      var acc = 0;
      var last = performance.now();
      function step(now) {
        if (!tourOn) { glideRaf = null; glideWroteY = null; return; }
        var dstep = now - last;
        last = now;
        if (tourPausedF) { glideRaf = requestAnimationFrame(step); return; }
        if (dstep > 64) dstep = 64;
        acc += dstep;
        var t = clamp(acc / dur, 0, 1);
        var e = linear ? t : smoothstep(t);
        var y = Math.round(from + dist * e);
        window.scrollTo({ top: y, behavior: 'instant' });
        glideWroteY = y;
        if (t < 1) { glideRaf = requestAnimationFrame(step); }
        else { glideRaf = null; glideWroteY = null; done(); }
      }
      glideRaf = requestAnimationFrame(step);
    }
    function tourRun(steps, i) {
      if (!tourOn) return;
      if (i >= steps.length) { tourCancel(); return; }
      var st = steps[i];
      if (st.dwell !== undefined) {
        tourTimer = setTimeout(function fire() {
          if (!tourOn) return;
          if (tourPausedF) { tourTimer = setTimeout(fire, 250); return; }
          tourTimer = null;
          tourRun(steps, i + 1);
        }, st.dwell);
        return;
      }
      if (st.film !== undefined && films[st.film] && films[st.film].tourPlay) {
        tourCurFilm = st.film;
        films[st.film].tourPlay();
      }
      tourSeg(st.to, st.dur, st.linear, function () {
        if (st.film !== undefined && films[st.film] && films[st.film].tourStop) {
          films[st.film].tourStop();
          tourCurFilm = null;
        }
        tourRun(steps, i + 1);
      });
    }
    function tour(btn) {
      if (tourOn) { tourSetPaused(!tourPausedF); return; }
      cancelGlide();
      blockPendingY = null;
      tourOn = true;
      window.__agbeTourOn = true;
      tourBtnEl = btn || tourBtnEl;
      tourPausedF = false;
      if (tourBtnEl) { tourLabel = tourBtnEl.textContent; tourBtnEl.textContent = 'Pause'; }
      var G = geo();
      var steps = [];
      steps.push({ to: 0, dur: Math.min(1400, 300 + window.pageYOffset * 0.1) });
      steps.push({ dwell: 500 });
      for (var k = 0; k < N; k += 1) {
        var A = G.entryStart + (k + 1) * G.beat;
        var S = k === 0 ? G.entryStart + FILM1_SCRUB_START * G.vh : (A - G.beat) + FILM_HOLD + FILM_FADE;
        steps.push({ to: S, dur: k === 0 ? 1700 : 700 });
        /* A film leg runs for the video's OWN duration so it plays at true
           speed. A still has no duration, so it gets a fixed read-it pass
           rather than the 3s default a missing duration would fall back to. */
        var vdur = films[k] && films[k].duration ? films[k].duration() : 0;
        var legDur = vdur ? Math.max(1500, vdur * 1000) : 1900;
        steps.push({ to: A, dur: legDur, linear: true, film: k });
      }
      if (GEO.map.specs) {
        steps.push({ to: GEO.map.specs.top, dur: 2600 });
        steps.push({ dwell: 1800 });
      }
      if (GEO.map.choose) steps.push({ to: GEO.map.choose.top, dur: 2200 });
      tourRun(steps, 0);
    }
    return { section: section, films: films, update: update, anchors: anchors, tour: tour, tourCancel: tourCancel };
  }
  var journey = journeyFilm();

  var header = root.querySelector('[data-agbe-header]');

  /* Section entries CROSSFADE: while a film section approaches, its stage
     is held over the viewport by transform and fades in above the outgoing
     one - one language of fades everywhere, replacing the slide-over
     curtain. Static sections below keep their natural scroll. */
  /* Header and rail anchors glide to the section top: full speed through
     the journey, then a long deceleration into place (easeOutQuart). Any
     wheel or touch input hands control straight back to the user. */
  var glideRaf = null;
  var glideDirSign = 1;
  var glideWroteY = null;          /* what the glide last wrote, to spot outside interference */
  var settleHoldY = null;          /* set on user cancel: magnet stays off until they really scroll */
  var settleHoldT = 0;
  var settleHoldTimer = null;
  function setHold() {
    settleHoldY = window.pageYOffset;
    settleHoldT = performance.now();
    /* The hold releases on real scrolling - or expires after stillness so
       a stray cancel can never leave the magnet dead. */
    if (settleHoldTimer) clearTimeout(settleHoldTimer);
    if (window.__agbeHoldExpire) settleHoldTimer = setTimeout(window.__agbeHoldExpire, 1300);
  }
  function cancelGlide() {
    if (glideRaf) { cancelAnimationFrame(glideRaf); glideRaf = null; }
    glideWroteY = null;
  }
  function userInterrupt(e) {
    /* A tap ON the tour button must reach its click handler untouched -
       cancelling here killed the tour AND the click then restarted it. */
    if (window.__agbeTourOn && e && e.target && e.target.closest && e.target.closest('[data-tour]')) return;
    if (window.__agbeTourCancel) window.__agbeTourCancel();
    if (glideRaf) setHold();
    cancelGlide();
    blockPendingY = null;
  }
  /* The anchor blocker never fights live momentum: gliding backward while
     the browser is still pushing forward oscillates a few px per frame
     (visible as caption jitter). Crossing a poster at speed just REMEMBERS
     the beat; the return glide fires once the momentum has died. */
  var blockPendingY = null;
  var blockPendingDir = 0;
  /* Where the last settle/capture glide landed - if momentum immediately
     drags the page off that poster, the gesture still owes it. */
  var glideLandY = null;
  var glideLandT = 0;
  var wheelEMA = 0;
  var touchActive = false;
  var TOUCH_DEVICE = navigator.maxTouchPoints > 0;
  addEventListener('wheel', function (e) {
    /* Momentum tails keep emitting decaying wheel events; they are not user
       intent. During a glide only a SPIKE (clearly bigger than the decaying
       tail) or an OPPOSING wheel hands control back - which lets the magnet
       take over mid-momentum without the tail assassinating it. */
    var mag = Math.abs(e.deltaY) + Math.abs(e.deltaX);
    if (mag < 1) return;
    if (window.__agbeTourCancel) window.__agbeTourCancel();
    /* real input hands control back - the event IS the intent (the old
       position-reversal heuristic false-fired on iOS's lagged reads) */
    if (glideRaf) { cancelGlide(); setHold(); }
    if (window.__agbeSettleTick) window.__agbeSettleTick();
    if (glideRaf) {
      var spike = mag >= Math.max(4, wheelEMA * 1.5);
      var opposing = e.deltaY !== 0 && (e.deltaY > 0) !== (glideDirSign > 0);
      if (spike || opposing) userInterrupt();
    }
    /* A pending block belongs to the CURRENT gesture: an opposing wheel or
       a fresh same-direction spike is a new gesture - release the beat. */
    if (blockPendingY !== null && e.deltaY !== 0) {
      var pOpposing = (e.deltaY > 0) !== (blockPendingDir > 0);
      var pSpike = mag >= Math.max(4, wheelEMA * 1.5);
      if (pOpposing || pSpike) blockPendingY = null;
    }
    wheelEMA = wheelEMA * 0.7 + mag * 0.3;
  }, { passive: true });
  addEventListener('touchstart', function (e) { touchActive = true; userInterrupt(e); }, { passive: true });
  addEventListener('keydown', function (e) {
    if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].indexOf(e.key) !== -1 && glideRaf) {
      cancelGlide();
      setHold();
    }
  });
  addEventListener('touchend', function () { touchActive = false; }, { passive: true });
  addEventListener('touchcancel', function () { touchActive = false; }, { passive: true });
  addEventListener('keydown', function (e) {
    if ([' ', 'Spacebar', 'ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'Home', 'End'].indexOf(e.key) !== -1) userInterrupt();
  }, { passive: true });
  function glideTo(y, v0) {
    cancelGlide();
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      window.scrollTo({ top: y, behavior: 'instant' });
      return;
    }
    var from = window.pageYOffset;
    var dist = y - from;
    if (!dist) return;
    glideDirSign = dist > 0 ? 1 : -1;
    var dur = Math.min(2600, 420 + Math.abs(dist) * 0.16);
    /* Nav jumps launch fast and decelerate (easeOutQuart). Settles instead
       pick up at the scroll's own residual velocity and ramp from there -
       a cubic Hermite whose starting slope is the handover speed - so the
       takeover is a continuation of the user's motion, not a lurch. */
    var ease;
    if (v0 !== undefined) {
      dur = Math.min(1600, 480 + Math.abs(dist) * 0.55);
      var m0 = clamp((v0 * dur) / dist, 0, 3);
      ease = function (t) { return (t * t * t - 2 * t * t + t) * m0 + (-2 * t * t * t + 3 * t * t); };
    } else {
      ease = function (t) { return 1 - Math.pow(1 - t, 4); };
    }
    var wasSettle = v0 !== undefined;
    var t0 = null;
    function step(ts) {
      /* Something else moved the page AHEAD of us: native momentum under
         the glide - absorb it and RE-AIM so the landing stays exact.
         Movement BEHIND us is NOT the user fighting: iOS reports scroll
         positions hundreds of px behind instant writes mid-glide (sim
         beacon measured -754px), so lag must be ignored. Real user input
         cancels glides through its own events (touchstart, wheel, keys)
         - no position heuristic needed. */
      if (glideWroteY !== null) {
        var dev = window.pageYOffset - glideWroteY;
        if (Math.abs(dev) > 3 && (dev > 0) === (dist > 0)) {
          from += dev;
          dist -= dev;
        }
      }
      if (t0 === null) t0 = ts;
      var t = clamp((ts - t0) / dur, 0, 1);
      var wrote = from + dist * ease(t);
      window.scrollTo({ top: wrote, behavior: 'instant' });
      /* record what we WROTE - reading back mid-glide returns iOS's
         lagged compositor position, poisoning every comparison */
      glideWroteY = wrote;
      if (t < 1) { glideRaf = requestAnimationFrame(step); }
      else {
        glideRaf = null; glideWroteY = null;
        /* The glide reached its intended target: any pending beat armed
           during our own flight is noise - iOS's compositor reports
           scroll positions a beat behind our writes, which used to arm a
           return-to-crossed-beat that yanked the page straight back off
           the landing (dead-feeling ORDER NOW on phones). */
        blockPendingY = null;
        if (wasSettle) { glideLandY = y; glideLandT = performance.now(); }
      }
    }
    glideRaf = requestAnimationFrame(step);
  }

  Array.prototype.forEach.call(root.querySelectorAll('.agbe-header a[href^="#"], .agbe-rail a[href^="#"], a.agbe-btn[href^="#"]'), function (link) {
    link.addEventListener('click', function (e) {
      // getElementById, not querySelector: an id that starts with a digit
      // (e.g. #8-16kg-kettlebell) is not a valid selector and threw.
      var target = document.getElementById(link.getAttribute('href').slice(1));
      if (!target) return;
      e.preventDefault();
      glideTo(target.getBoundingClientRect().top + window.pageYOffset);
      if (history.replaceState) history.replaceState(null, '', link.getAttribute('href'));
    });
  });

  /* --- Idle settle: a soft magnet, never a lock ---------------------------
     While the user scrolls, nothing interferes; slow scrolling scrubs the
     films at exactly their pace. When scrolling goes idle within reach of a
     poster moment (a caption fully on stage, or the top of a content
     section) the page eases onto it and the films settle with it.
     Asymmetric reach: anchors ahead of the travel direction catch from
     further away than anchors behind, so it never fights forward intent.
     Any wheel, touch or key input cancels the settle instantly. */
  var settleEnabled = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  if (settleEnabled) {
    function wantMeasure() { return /agbedebug/.test(location.search + location.hash); }
    var measureMode = wantMeasure();
    var settleTimer = null;
    var settleLastY = window.pageYOffset;
    var settleLastT = 0;
    var settleVel = 0;               /* smoothed px/ms, the handover speed */
    var settleDir = 1;
    var SETTLE_TAIL_SECTIONS = ['specs', 'choose', 'viewer', 'closer'];
    function settleAnchors() {
      if (!GEO.map.films) geoRefresh();
      var film = journey ? journey.anchors() : [];
      var tail = [];
      SETTLE_TAIL_SECTIONS.forEach(function (name) {
        if (GEO.map[name]) tail.push(GEO.map[name].top);
      });
      var max = GEO.max;
      var inRange = function (y) { return y > 0 && y < max - 2; };
      return {
        film: film.filter(inRange).sort(function (a, b) { return a - b; }),
        tail: tail.filter(inRange).sort(function (a, b) { return a - b; })
      };
    }

    window.__agbeHoldExpire = function () {
      if (settleHoldY !== null && performance.now() - settleHoldT >= 1200) {
        settleHoldY = null;
        trySettle();
      }
    };
    function trySettle() {
      if (measureMode || glideRaf || settleHoldY !== null) return;
      var y = window.pageYOffset;
      var vh = GEO.vh;
      /* No idle snapping: the page rests wherever the scroll stops. The
         only settles left are the two edges - scrolling up through the
         hero returns to the very top, and a stop near the foot of the
         page completes to the end. Fast scrolling is governed separately
         by the flick capture and the crossing blocker. */
      var maxY = GEO.max;
      var heroEnd = GEO.map.films ? GEO.map.films.top - 0.6 * vh : 0;
      if (settleDir < 0 && y > 4 && y < heroEnd) { glideTo(0, settleVel); return; }
      if (settleDir > 0 && y < maxY - 2 && y > maxY - 0.6 * vh) { glideTo(maxY, settleVel); return; }
    }

    /* --- Anchor debug overlay: add #agbedebug to the URL ----------------
       Red lines = film posters (the line sits at the viewport centre when
       settled on that anchor). Cyan = content-section tops. HUD shows live
       position, gap fraction and handover velocity. Testing aid only. */
    var dbgWrap = null, dbgHud = null;
    function dbgStart() {
      if (dbgWrap) return;
      dbgWrap = document.createElement('div');
      dbgWrap.style.cssText = 'position:absolute;left:0;top:0;width:100%;height:0;z-index:80;pointer-events:none';
      var dbgNames = ['02.1', '02.2', '03.1', '03.2', '04.1', '04.2', '05.1', '05.2'];
      function dbgDraw() {
        var A = settleAnchors();
        var vh = window.innerHeight;
        dbgWrap.innerHTML = '';
        A.film.concat(A.tail).forEach(function (a, i) {
          var isFilm = i < A.film.length;
          var line = document.createElement('div');
          var label = isFilm ? (dbgNames[i] || '?') : ['06', '07', '08', '09'][i - A.film.length] || '?';
          line.style.cssText = 'position:absolute;left:0;width:100%;border-top:1px dashed ' +
            (isFilm ? '#e10600' : '#00e5ff') + ';top:' + (a + vh / 2) + 'px';
          line.innerHTML = '<span style="position:absolute;right:8px;top:2px;font:700 10px/1 monospace;color:' +
            (isFilm ? '#e10600' : '#00e5ff') + ';background:#0a0a0acc;padding:3px 6px">' + label + ' &middot; ' + Math.round(a) + '</span>';
          dbgWrap.appendChild(line);
        });
      }
      dbgHud = document.createElement('div');
      dbgHud.style.cssText = 'position:fixed;left:10px;bottom:10px;z-index:99;font:700 11px/1.6 monospace;color:#0f0;background:#0a0a0add;padding:8px 10px;pointer-events:none;white-space:pre';
      /* Frame-health meter: dropped rAF %, main-thread long tasks, and how
         often the scrub wanted a frame that was not decoded in time. */
      var jank = { frames: 0, drops: 0, long: 0, worst: 0, lastTs: 0 };
      dbgHud.__jank = jank;
      try {
        new PerformanceObserver(function (list) {
          list.getEntries().forEach(function (e) {
            jank.long += 1;
            jank.worst = Math.max(jank.worst, Math.round(e.duration));
          });
        }).observe({ type: 'longtask' });
      } catch (eo) {}
      document.body.appendChild(dbgWrap);
      document.body.appendChild(dbgHud);
      dbgDraw();
      addEventListener('resize', dbgDraw);
      /* Geometry reads are throttled to 4Hz - at 60Hz they were enough
         layout work to jank scrolling on the full live page. */
      var dbgRun = [], dbgLastMeasure = 0;
      (function dbgTick(ts) {
        if (!dbgWrap) return;
        if (!dbgLastMeasure || ts - dbgLastMeasure > 250) {
          dbgLastMeasure = ts || 1;
          var A = settleAnchors();
          dbgRun = A.film.slice();
          if (A.tail.length) dbgRun.push(A.tail[0]);
        }
        var y = window.pageYOffset, info = 'outside journey';
        if (dbgRun.length > 1 && y > dbgRun[0] && y < dbgRun[dbgRun.length - 1]) {
          var i = 0;
          while (i < dbgRun.length - 2 && dbgRun[i + 1] <= y) i++;
          info = 'gap ' + i + ' f=' + (((y - dbgRun[i]) / (dbgRun[i + 1] - dbgRun[i])) * 100).toFixed(1) + '%';
        }
        var jk = dbgHud.__jank;
        if (jk.lastTs) {
          jk.frames += 1;
          if (ts - jk.lastTs > 26) jk.drops += 1;
        }
        jk.lastTs = ts;
        dbgHud.textContent = window.__agbeEngine + '\ny ' + Math.round(y) + '  ' + info +
          '\nvel ' + settleVel.toFixed(2) + ' px/ms  dir ' + settleDir +
          '\ndrops ' + (jk.frames ? (jk.drops * 100 / jk.frames).toFixed(1) : '0.0') + '%  longtasks ' + jk.long + ' (worst ' + jk.worst + 'ms)' +
          '\nframe misses ' + (window.__agbeMisses || 0) +
          '\nMAGNET OFF - measuring';
        requestAnimationFrame(dbgTick);
      })();
    }
    function dbgStop() {
      if (dbgWrap) { dbgWrap.remove(); dbgWrap = null; }
      if (dbgHud) { dbgHud.remove(); dbgHud = null; }
    }
    if (measureMode) dbgStart();
    addEventListener('hashchange', function () {
      measureMode = wantMeasure();
      if (measureMode) dbgStart(); else dbgStop();
    });

    /* A wheel event resets the idle clock - and REARMS it. Trailing
       momentum ticks that move nothing used to clear the timer and leave
       the magnet dead at the end of real gestures. */
    /* Idle resolution: a pending blocked beat wins over the ordinary
       settle - the gesture that crossed it still owes it a landing. */
    function settleFire() {
      if (blockPendingY !== null) {
        var bp = blockPendingY;
        blockPendingY = null;
        glideTo(bp, settleVel);
        return;
      }
      trySettle();
    }
    window.__agbeSettleTick = function () {
      if (settleTimer) clearTimeout(settleTimer);
      settleTimer = setTimeout(settleFire, 90);
    };

    var settleSpeedPrev = 0;
    var settleDecay = 0;
    addEventListener('scroll', function () {
      var y = window.pageYOffset;
      var prevY = settleLastY;
      var now = performance.now();
      if (Math.abs(y - settleLastY) > 1) settleDir = y > settleLastY ? 1 : -1;
      var dt = now - settleLastT;
      if (dt > 0 && dt < 200 && !glideRaf) {
        settleVel = settleVel * 0.6 + ((y - settleLastY) / dt) * 0.4;
      } else if (!glideRaf) {
        settleVel = 0;
      }
      settleLastY = y;
      settleLastT = now;
      /* A real scroll away from the cancel point re-arms the magnet */
      if (settleHoldY !== null && Math.abs(y - settleHoldY) > 4) settleHoldY = null;
      if (settleTimer) clearTimeout(settleTimer);
      /* Even mid-glide, FOREIGN movement (momentum running underneath)
         that crosses a poster owes it a landing: the glide can be dragged
         past its own target and abort - the pending beat guarantees the
         return once the momentum dies. */
      if (glideRaf && glideWroteY !== null && Math.abs(y - glideWroteY) > 24 &&
          Math.abs(y - prevY) > 2 && !touchActive && !measureMode) {
        var XA = settleAnchors();
        var xrun = [0].concat(XA.film);
        if (XA.tail.length) xrun.push(XA.tail[0]);
        var xed = null;
        if (y > prevY) {
          for (var xi = 0; xi < xrun.length; xi += 1) {
            if (xrun[xi] > prevY + 4 && xrun[xi] <= y) { xed = xrun[xi]; break; }
          }
        } else {
          for (var xj = xrun.length - 1; xj >= 0; xj -= 1) {
            if (xrun[xj] < prevY - 4 && xrun[xj] >= y) { xed = xrun[xj]; break; }
          }
        }
        if (xed !== null && xed > 0) { blockPendingY = xed; blockPendingDir = y > prevY ? 1 : -1; }
      }
      if (glideRaf) return;
      /* Predictive takeover: three consecutive shrinking velocity readings
         under the threshold is decaying momentum, not intent - hand over
         mid-motion at the current speed instead of waiting for the crawl
         to die. A fresh finger or a wheel spike cancels as usual. */
      var speed = Math.abs(settleVel);
      if (speed < settleSpeedPrev - 0.004) settleDecay += 1; else settleDecay = 0;
      settleSpeedPrev = speed;
      /* Momentum dragging the page off a poster it JUST landed on is the
         same gesture still running - the beat is still owed. A genuinely
         new swipe (wheel spike) clears this pending immediately. */
      if (glideLandY !== null && performance.now() - glideLandT < 400 &&
          Math.abs(prevY - glideLandY) < 8 && Math.abs(y - prevY) > 2 && !touchActive) {
        blockPendingY = glideLandY;
        blockPendingDir = y > prevY ? 1 : -1;
        glideLandY = null;
      }
      /* A blocked beat waits out the momentum, then collects its landing.
         0.15px/ms leaves only a tail the glide's own deadband absorbs. */
      if (blockPendingY !== null && !touchActive) {
        if (speed < 0.15) {
          var bp = blockPendingY;
          blockPendingY = null;
          glideTo(bp, settleVel);
          return;
        }
        settleTimer = setTimeout(settleFire, 90);
        return;
      }
      if (!touchActive && settleDecay >= 3 && speed > 0.02 && speed < 0.5) {
        settleDecay = 0;
        trySettle();
        if (glideRaf) return;
      }
      /* Flick capture: a big swipe never blows through a beat - but it
         FLIES FREE at its own speed first. Capture engages only inside
         braking distance of the next anchor (scaled to velocity), so the
         gesture keeps its native pace and then decelerates onto the mark.
         A second swipe mid-brake advances one more beat. */
      if (!touchActive && settleHoldY === null && !measureMode && speed >= 1.1) {
        var FA = settleAnchors();
        var frun = [0].concat(FA.film);
        if (FA.tail.length) frun.push(FA.tail[0]);
        var flast = frun[frun.length - 1];
        /* Blocker: at flick speed a single event can hop clean over the
           braking window. If this movement CROSSED a poster, the gesture
           ends there - a big scroll never carries past a beat. */
        var crossed = null;
        if (y > prevY + 2) {
          for (var ci = 0; ci < frun.length; ci += 1) {
            if (frun[ci] > prevY + 4 && frun[ci] <= y) { crossed = frun[ci]; break; }
          }
        } else if (y < prevY - 2) {
          for (var cj = frun.length - 1; cj >= 0; cj -= 1) {
            if (frun[cj] < prevY - 4 && frun[cj] >= y) { crossed = frun[cj]; break; }
          }
        }
        if (crossed !== null && crossed > 0) {
          if (TOUCH_DEVICE) {
            /* Momentum phase (the finger is up - touchActive gates this
               branch): a programmatic write interrupts iOS's fling, so the
               scroll CANCELS exactly at the crossed beat instead of sailing
               past and gliding back. The pending beat stays armed as the
               fallback for engines that let the fling continue. */
            window.scrollTo({ top: crossed, behavior: 'instant' });
            settleLastY = crossed;
            settleVel = 0;
          }
          blockPendingY = crossed;
          blockPendingDir = settleDir;
          settleTimer = setTimeout(settleFire, 90);
          return;
        }
        if (y > 0 && y < flast) {
          var ftarget = null;
          if (settleDir > 0) {
            for (var fi = 0; fi < frun.length; fi += 1) {
              if (frun[fi] > y + 4) { ftarget = frun[fi]; break; }
            }
          } else {
            for (var fj = frun.length - 1; fj >= 0; fj -= 1) {
              if (frun[fj] < y - 4) { ftarget = frun[fj]; break; }
            }
          }
          var braking = Math.min(900, Math.max(260, speed * 320));
          if (ftarget !== null && Math.abs(ftarget - y) <= braking) {
            if (TOUCH_DEVICE) {
              /* iOS's native scroller owns the scroll during momentum and
                 overrides programmatic writes frame-by-frame - gliding now
                 would be a visible tug-of-war. Remember the beat; the
                 landing happens the moment momentum dies. */
              blockPendingY = ftarget;
              blockPendingDir = settleDir;
              settleTimer = setTimeout(settleFire, 90);
              return;
            }
            glideTo(ftarget, settleVel);
            return;
          }
        }
      }
      settleTimer = setTimeout(settleFire, 90);
    }, { passive: true });
  }

  /* Back to top: every section carries one. */
  Array.prototype.forEach.call(root.querySelectorAll('[data-totop]'), function (btn) {
    btn.addEventListener('click', function () { glideTo(0, 0); });
  });

  /* Product photos arrive on studio backgrounds (white or grey) that sit
     ugly on the dark cards. Cut the backdrop out AT RUNTIME: redraw via a
     CORS-clean canvas and flood-fill transparency in from the corners,
     keyed to each corner's own colour. Any failure (CORS, decode) leaves
     the original photo untouched - never worse than before. */
  function agbeCutout(imgEl) {
    var src = imgEl.currentSrc || imgEl.src;
    if (!src) return;
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      try {
        var w = probe.naturalWidth, h = probe.naturalHeight;
        if (!w || !h || w * h > 1200000) return;
        var c = document.createElement('canvas');
        c.width = w; c.height = h;
        var x = c.getContext('2d');
        x.drawImage(probe, 0, 0);
        var d = x.getImageData(0, 0, w, h);
        var px = d.data;
        var TOL = 52;
        var stack = [];
        var seen = new Uint8Array(w * h);
        [[0, 0], [w - 1, 0], [0, h - 1], [w - 1, h - 1]].forEach(function (corner) {
          var ci = (corner[1] * w + corner[0]) * 4;
          var cr = px[ci], cg = px[ci + 1], cb = px[ci + 2];
          if (cr + cg + cb < 240) return;   /* dark corner: not a studio backdrop */
          stack.push([corner[0], corner[1], cr, cg, cb]);
        });
        while (stack.length) {
          var it = stack.pop();
          var sx = it[0], sy = it[1], cr = it[2], cg = it[3], cb = it[4];
          var idx = sy * w + sx;
          if (seen[idx]) continue;
          seen[idx] = 1;
          var o = idx * 4;
          if (Math.abs(px[o] - cr) + Math.abs(px[o + 1] - cg) + Math.abs(px[o + 2] - cb) > TOL * 3) continue;
          px[o + 3] = 0;
          if (sx > 0) stack.push([sx - 1, sy, cr, cg, cb]);
          if (sx < w - 1) stack.push([sx + 1, sy, cr, cg, cb]);
          if (sy > 0) stack.push([sx, sy - 1, cr, cg, cb]);
          if (sy < h - 1) stack.push([sx, sy + 1, cr, cg, cb]);
        }
        /* Pass two: enclosed pockets (inside the handle) can't be reached
           from the corners. Clear any LARGE leftover region that matches the
           backdrop colour - small light details (lettering, highlights)
           stay because they never reach the size gate. */
        var refs = [];
        [[0, 0], [w - 1, 0], [0, h - 1], [w - 1, h - 1]].forEach(function (corner) {
          var ci = (corner[1] * w + corner[0]) * 4;
          if (px[ci] + px[ci + 1] + px[ci + 2] >= 240) refs.push([px[ci], px[ci + 1], px[ci + 2]]);
        });
        if (refs.length) {
          /* Pockets and drop shadows are DESATURATED AND BRIGHT - grey
             paper, grey shadow. The red band is saturated, the iron is
             dark, and small bright details (lettering, speculars) are
             protected by the size gate, so this signature only ever
             matches leftover backdrop. */
          var isBackdrop = function (o3) {
            var r = px[o3], g = px[o3 + 1], b = px[o3 + 2];
            var mx = Math.max(r, g, b), mn = Math.min(r, g, b);
            if ((mx - mn) < 42 && (r + g + b) > 300) return true;
            /* Chroma backdrops (green screen) are saturated: also match
               pockets that sit tight on a corner colour. */
            for (var rk = 0; rk < refs.length; rk += 1) {
              if (Math.abs(r - refs[rk][0]) + Math.abs(g - refs[rk][1]) + Math.abs(b - refs[rk][2]) <= 156) return true;
            }
            return false;
          };
          var minRegion = Math.max(1200, (w * h) / 220);
          var comp = new Int32Array(w * h);
          for (var pi = 0; pi < w * h; pi += 1) {
            if (seen[pi] || comp[pi]) continue;
            var o2 = pi * 4;
            if (px[o2 + 3] === 0) continue;
            if (!isBackdrop(o2)) continue;
            var members = [pi];
            comp[pi] = 1;
            var qi = 0;
            while (qi < members.length) {
              var cur = members[qi]; qi += 1;
              var cx = cur % w, cy = (cur / w) | 0;
              [[cx - 1, cy], [cx + 1, cy], [cx, cy - 1], [cx, cy + 1]].forEach(function (nb) {
                if (nb[0] < 0 || nb[0] >= w || nb[1] < 0 || nb[1] >= h) return;
                var ni = nb[1] * w + nb[0];
                if (comp[ni] || seen[ni]) return;
                var no = ni * 4;
                if (px[no + 3] === 0) return;
                if (!isBackdrop(no)) return;
                comp[ni] = 1;
                members.push(ni);
              });
            }
            if (members.length >= minRegion) {
              for (var mi = 0; mi < members.length; mi += 1) px[members[mi] * 4 + 3] = 0;
            }
          }
        }
        /* Pass three: shadows are GRADIENTS - any hard threshold slices
           them into stair-steps. March out from every cleared pixel
           through desaturated neighbours, fading alpha with darkness, so
           leftover shadow dissolves instead of ending in a cliff. The
           march can't leave desaturated territory, so the bell and the
           red band stay solid. */
        var frontier = [];
        for (var fi2 = 0; fi2 < w * h; fi2 += 1) {
          if (px[fi2 * 4 + 3] === 0) frontier.push(fi2);
        }
        var feathered = new Uint8Array(w * h);
        while (frontier.length) {
          var fcur = frontier.pop();
          var fx = fcur % w, fy = (fcur / w) | 0;
          [[fx - 1, fy], [fx + 1, fy], [fx, fy - 1], [fx, fy + 1]].forEach(function (nb) {
            if (nb[0] < 0 || nb[0] >= w || nb[1] < 0 || nb[1] >= h) return;
            var ni = nb[1] * w + nb[0];
            if (feathered[ni]) return;
            var no = ni * 4;
            if (px[no + 3] === 0) return;
            var r = px[no], g = px[no + 1], b = px[no + 2];
            var sum = r + g + b;
            if (Math.max(r, g, b) - Math.min(r, g, b) >= 50 || sum <= 150) return;
            feathered[ni] = 1;
            var t = (sum - 150) / 450;
            if (t > 1) t = 1;
            var a = Math.round((1 - t) * 255);
            if (a < px[no + 3]) px[no + 3] = a;
            frontier.push(ni);
          });
        }
        x.putImageData(d, 0, 0);
        c.toBlob(function (blob) {
          if (blob) imgEl.src = URL.createObjectURL(blob);
        }, 'image/png');
      } catch (eCut) {}
    };
    probe.src = src;
  }
  /* Cutouts crunch hundreds of thousands of pixels - staggered, and never
     while the tour is driving, so they can't stall its clock. */
  (function () {
    /* Cards AND the dims figure. The chrome sibling had to skip its dims
       photo because a luminance key eats bright chrome and leaves a ghost.
       A matt black dumbbell on a white sweep is the opposite case: the key
       takes the background and leaves the subject whole, so both qualify.
       Every source here must be a white-sweep studio shot for that to hold. */
    var cutQueue = Array.prototype.slice.call(root.querySelectorAll('.agbe-card-img, [data-cutout]'));
    function cutNext() {
      if (!cutQueue.length) return;
      if (window.__agbeTourOn) { setTimeout(cutNext, 1200); return; }
      agbeCutout(cutQueue.shift());
      setTimeout(cutNext, 400);
    }
    setTimeout(cutNext, 700);
  })();

  /* PICK THE RANGE deck: fanned stack that auto-cycles (pausing on hover
     and offscreen), drags, and answers the dots; the front card tilts in
     3D with a following spotlight on pointer devices. */
  Array.prototype.forEach.call(root.querySelectorAll('[data-deck]'), function (deck) {
    var cards = Array.prototype.slice.call(deck.querySelectorAll('[data-deck-card]'));
    var dotsWrap = deck.nextElementSibling && deck.nextElementSibling.hasAttribute && deck.nextElementSibling.hasAttribute('data-deck-dots') ? deck.nextElementSibling : null;
    var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.querySelectorAll('i')) : [];
    if (cards.length < 2) return;
    var order = cards.map(function (_, i) { return i; });
    var hovering = false, visible = false, timer = null;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var deckMq = window.matchMedia ? window.matchMedia('(max-width: 900px)') : null;
    var deckIsCarousel = deckMq ? deckMq.matches : false;
    if (deckMq && deckMq.addEventListener) {
      deckMq.addEventListener('change', function (ev) {
        if (!ev.matches) {
          /* crossed to desktop: strip stack state so the grid renders clean */
          if (timer) { clearInterval(timer); timer = null; }
          cards.forEach(function (c) { c.className = 'agbe-deck-card'; });
        } else {
          paint();
          arm();
        }
      });
    }
    if (!deckIsCarousel) {
      /* Desktop: static 3-up grid; each card gets the spotlight tilt. */
      if (!reduced && window.matchMedia('(hover: hover)').matches) {
        /* one deck-level listener feeds every card's glow mask, so the
           red edge lights up across neighbouring tiles near the cursor */
        deck.addEventListener('pointermove', function (e) {
          cards.forEach(function (wrap) {
            var card = wrap.querySelector('.agbe-card');
            var r = card.getBoundingClientRect();
            card.style.setProperty('--gx', (((e.clientX - r.left) / r.width) * 100).toFixed(1) + '%');
            card.style.setProperty('--gy', (((e.clientY - r.top) / r.height) * 100).toFixed(1) + '%');
          });
          deck.classList.add('agbe-glow-on');
        });
        deck.addEventListener('pointerleave', function () { deck.classList.remove('agbe-glow-on'); });
        cards.forEach(function (wrap) {
          var card = wrap.querySelector('.agbe-card');
          card.addEventListener('pointermove', function (e) {
            var r = card.getBoundingClientRect();
            var px2 = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
            card.style.transform = 'rotateY(' + ((px2 - 0.5) * 7).toFixed(2) + 'deg) rotateX(' + ((0.5 - py) * 5).toFixed(2) + 'deg)';
            card.style.setProperty('--mx', (px2 * 100).toFixed(1) + '%');
            card.style.setProperty('--my', (py * 100).toFixed(1) + '%');
          });
          card.addEventListener('pointerleave', function () { card.style.transform = ''; });
        });
      }
      return;
    }
    function paint() {
      order.forEach(function (cardIdx, pos) {
        cards[cardIdx].className = 'agbe-deck-card pos' + Math.min(pos, 2);
      });
      dots.forEach(function (d, di) { d.className = di === order[0] ? 'on' : ''; });
    }
    function advance(dir) {
      if (dir > 0) order.push(order.shift());
      else order.unshift(order.pop());
      paint();
    }
    function arm() {
      if (timer) { clearInterval(timer); timer = null; }
      if (reduced) return;
      timer = setInterval(function () {
        if (!hovering && visible && !document.hidden) advance(1);
      }, 3200);
    }
    deck.addEventListener('pointerenter', function () { hovering = true; });
    deck.addEventListener('pointerleave', function () { hovering = false; });
    var downX = null;
    deck.addEventListener('pointerdown', function (e) { downX = e.clientX; });
    deck.addEventListener('pointerup', function (e) {
      if (downX === null) return;
      var dx = e.clientX - downX;
      downX = null;
      if (Math.abs(dx) > 36) { advance(dx < 0 ? 1 : -1); arm(); }
    });
    /* iOS swallows pointerup behind pointercancel while it arbitrates
       gestures - track touches explicitly so a swipe always lands */
    var tX = null, tY = null, tLastX = null;
    deck.addEventListener('touchstart', function (e) {
      tX = tLastX = e.touches[0].clientX;
      tY = e.touches[0].clientY;
    }, { passive: true });
    deck.addEventListener('touchmove', function (e) {
      if (tX !== null) tLastX = e.touches[0].clientX;
    }, { passive: true });
    deck.addEventListener('touchend', function (e) {
      if (tX === null) return;
      var touch = (e.changedTouches && e.changedTouches[0]) || null;
      var endX = touch ? touch.clientX : tLastX;
      var endY = touch ? touch.clientY : tY;
      var dx = endX - tX, dy = endY - tY;
      tX = tY = tLastX = null;
      if (Math.abs(dx) > 36 && Math.abs(dx) > Math.abs(dy)) {
        advance(dx < 0 ? 1 : -1);
        arm();
      }
    }, { passive: true });
    dots.forEach(function (d, di) {
      function go() { while (order[0] !== di) order.push(order.shift()); paint(); arm(); }
      d.addEventListener('click', go);
      d.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); } });
    });
    var prevBtn = deck.querySelector('[data-deck-prev]');
    var nextBtn = deck.querySelector('[data-deck-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { advance(-1); arm(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { advance(1); arm(); });
    if (typeof IntersectionObserver === 'function') {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
      }, { threshold: 0.25 }).observe(deck);
    } else { visible = true; }
    /* spotlight tilt on the front card - pointer devices only */
    if (!reduced && window.matchMedia && window.matchMedia('(hover: hover)').matches) {
      deck.addEventListener('pointermove', function (e) {
        var front = cards[order[0]];
        var card = front.querySelector('.agbe-card');
        var r = front.getBoundingClientRect();
        var px2 = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
        if (px2 < 0 || px2 > 1 || py < 0 || py > 1) return;
        card.style.transform = 'rotateY(' + ((px2 - 0.5) * 9).toFixed(2) + 'deg) rotateX(' + ((0.5 - py) * 7).toFixed(2) + 'deg)';
        card.style.setProperty('--mx', (px2 * 100).toFixed(1) + '%');
        card.style.setProperty('--my', (py * 100).toFixed(1) + '%');
      });
      deck.addEventListener('pointerleave', function () {
        cards.forEach(function (c) {
          var card = c.querySelector('.agbe-card');
          card.style.transform = '';
        });
      });
    }
    paint();
    arm();
  });

  /* Desktop shows the data sheet open; the fold is a phone pattern. */
  (function () {
    var specFold = root.querySelector('.agbe-specs .agbe-fold-dark');
    if (specFold && window.matchMedia && window.matchMedia('(min-width: 901px)').matches) {
      specFold.open = true;
    }
  })();

  /* Guided tour button (mobile header). */
  (function () {
    var tb = root.querySelector('[data-tour]');
    if (!tb || !journey || !journey.tour) return;
    tb.addEventListener('click', function () { journey.tour(tb); });
    document.addEventListener('keydown', function () { if (journey.tourCancel) journey.tourCancel(); });
  })();

  /* The hero size tiles borrow the deck's cursor-tracked red edge glow: ONE
     pointermove on the group writes --gx/--gy onto every tile, so values
     outside 0-100% are the point - a tile lights along the edge it shares
     with the one the cursor is actually over. Guarded by (hover:hover) and
     prefers-reduced-motion, matching the deck. */
  (function heroTileGlow() {
    var tiles = root.querySelector('.agbe-hero-tiles');
    if (!tiles) return;
    if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var items = Array.prototype.slice.call(tiles.querySelectorAll('a'));
    if (!items.length) return;
    tiles.addEventListener('pointermove', function (e) {
      items.forEach(function (el) {
        var r = el.getBoundingClientRect();
        el.style.setProperty('--gx', (((e.clientX - r.left) / r.width) * 100).toFixed(1) + '%');
        el.style.setProperty('--gy', (((e.clientY - r.top) / r.height) * 100).toFixed(1) + '%');
      });
      tiles.classList.add('agbe-glow-on');
    });
    tiles.addEventListener('pointerleave', function () {
      tiles.classList.remove('agbe-glow-on');
    });
  })();

  /* Order now inside the film captions: straight to the models section. */
  Array.prototype.forEach.call(root.querySelectorAll('[data-ordernow]'), function (btn) {
    btn.addEventListener('click', function () {
      var g = GEO.map.choose;
      if (g) glideTo(g.top, 0);
    });
  });

  /* --- The size chooser -------------------------------------------------
     Black Edition is ONE product with three outright variants, so unlike its
     Chrome sibling there is no route to compose: the buyer answers a single
     question and we add a single line item.

     SIZES is read from the DOM, not declared here. Every variant id, price,
     compare-at and availability flag rides in on the seg buttons that liquid
     rendered, which keeps the shop as the single source of truth. Nothing
     about this product is hardcoded in this file: a price change, a variant
     id change or a size selling out all land without a deploy.

     STOCK IS PART OF THE MODEL, not a decoration. The 32.5 kg sells out
     regularly and its inventory policy is DENY, so a sold-out size must never
     reach /cart/add.js. Availability is rendered by liquid, re-checked
     against the product .js on load, and re-read on every click.

     The fetch is r.ok checked; a failure keeps the server-rendered numbers
     rather than blanking them. Add-to-cart does NOT clear the basket: the
     buyer may be carrying a stand or a mat and this page has no business
     throwing that away. */
  (function () {
    var panel = root.querySelector('[data-sizer]');
    if (!panel) return;

    var SIZE_LABEL = { 235: '23.5 kg', 325: '32.5 kg', 415: '41.5 kg' };
    /* The brand says "weights in 1", never "settings". 4 kg to the max in
       1.5 kg increments: 14, 20 and 26 values respectively. */
    var SIZE_WEIGHTS = { 235: 14, 325: 20, 415: 26 };
    var SIZE_MAX = { 235: '23.5', 325: '32.5', 415: '41.5' };

    var sizeBtns = Array.prototype.slice.call(panel.querySelectorAll('[data-size]'));
    if (!sizeBtns.length) return;

    /* SIZES: built from what liquid rendered onto each button. */
    var SIZES = {};
    sizeBtns.forEach(function (b) {
      var k = b.getAttribute('data-size');
      var num = function (attr) {
        var n = parseInt(b.getAttribute(attr) || '', 10);
        return isNaN(n) ? 0 : n;
      };
      SIZES[k] = {
        id: num('data-variant'),
        price: num('data-price'),
        was: num('data-was'),
        available: b.getAttribute('data-available') === 'true'
      };
    });

    var PRICE = {}, WAS = {};
    Object.keys(SIZES).forEach(function (k) { PRICE[k] = SIZES[k].price; WAS[k] = SIZES[k].was; });

    var listEl = panel.querySelector('[data-size-list]');
    var totalEl = panel.querySelector('[data-size-total]');
    var headEl = panel.querySelector('[data-size-head]');
    var noteEl = panel.querySelector('[data-size-note]');
    var saveEl = panel.querySelector('[data-size-save]');
    var wasEl = panel.querySelector('[data-size-was]');
    var savingsEl = panel.querySelector('[data-size-savings]');
    var goBtn = panel.querySelector('[data-size-go]');
    var altEl = panel.querySelector('[data-size-alt]');
    var fallbackHref = panel.getAttribute('data-fallback-href') || '/collections/adjustable-dumbbells-1';
    var busy = false;

    /* Open on the default size, but never on one that is sold out: landing on
       a dead button is worse than landing on a size they did not ask for. */
    var size = panel.getAttribute('data-size-default') || '415';
    if (!SIZES[size] || !SIZES[size].available) {
      var firstInStock = null;
      sizeBtns.forEach(function (b) {
        var k = b.getAttribute('data-size');
        if (firstInStock === null && SIZES[k] && SIZES[k].available) firstInStock = k;
      });
      if (firstInStock) size = firstInStock;
    }

    function pounds(n) { return '£' + n; }

    /* One painter for every price surface on the page. A [data-live-was] with
       no compare-at hides itself, and its SAVE pill with it, so a compare-at
       removed in admin cannot leave a stale "was" behind. */
    function paintOne(sel, attr, pick) {
      Array.prototype.forEach.call(root.querySelectorAll(sel), function (el) {
        var v = pick(el.getAttribute(attr));
        if (v === undefined || v <= 0) { el.hidden = true; return; }
        el.hidden = false;
        el.textContent = (attr === 'data-live-save' ? 'SAVE ' : '') + pounds(v);
      });
    }
    function paintPrices() {
      paintOne('[data-live-price]', 'data-live-price', function (k) { return PRICE[k]; });
      paintOne('[data-live-was]', 'data-live-was', function (k) { return WAS[k]; });
      paintOne('[data-live-save]', 'data-live-save', function (k) {
        return WAS[k] > PRICE[k] ? WAS[k] - PRICE[k] : 0;
      });
    }

    function recalc() {
      var s = SIZES[size];
      sizeBtns.forEach(function (b) {
        var k = b.getAttribute('data-size');
        b.classList.toggle('is-on', k === size);
        var out = !(SIZES[k] && SIZES[k].available);
        b.classList.toggle('is-soldout', out);
        b.setAttribute('aria-disabled', out ? 'true' : 'false');
      });
      if (!s) return;

      if (listEl) {
        listEl.innerHTML =
          '<li><span>Two dumbbells, 4 kg to ' + SIZE_MAX[size] + ' kg each</span><b>PAIR</b></li>'
          + '<li><span>Two storage bases</span><b>INCLUDED</b></li>'
          + '<li><span>' + SIZE_WEIGHTS[size] + ' weights in 1, 1.5 kg apart</span><b>PER DUMBBELL</b></li>';
      }
      if (totalEl) totalEl.textContent = pounds(PRICE[size]);
      if (headEl) headEl.textContent = 'THE ' + SIZE_LABEL[size].toUpperCase() + ' PAIR';

      if (saveEl) {
        var saved = WAS[size] > PRICE[size] ? WAS[size] - PRICE[size] : 0;
        if (saved > 0) {
          if (wasEl) wasEl.textContent = pounds(WAS[size]);
          if (savingsEl) savingsEl.textContent = 'SAVE ' + pounds(saved);
          saveEl.hidden = false;
        } else {
          saveEl.hidden = true;
        }
      }

      /* Sold out is a first-class state: the buy button goes away rather than
         going grey-but-clickable, and the product page takes over as the place
         to be told when it lands. */
      var canBuy = s.available && s.id > 0;
      if (goBtn) {
        goBtn.hidden = !canBuy;
        goBtn.disabled = busy || !canBuy;
      }
      if (altEl) altEl.hidden = canBuy;
      if (noteEl) {
        noteEl.textContent = canBuy
          ? SIZE_WEIGHTS[size] + ' weights in 1 per dumbbell, 1.5 kg apart. Sold as a pair, with a storage base each.'
          : 'The ' + SIZE_LABEL[size] + ' pair is out of stock at the moment. The product page will tell you when it is back.';
      }
    }

    /* Live refresh from the product .js: prices, compare-at AND availability,
       so a size that sold out since the page was cached cannot be added. One
       fetch, r.ok checked; on failure the server-rendered values stand. */
    (function refreshFromShop() {
      fetch(fallbackHref + '.js').then(function (r) {
        if (!r.ok) throw new Error('product ' + r.status);
        return r.json();
      }).then(function (prod) {
        (prod.variants || []).forEach(function (v) {
          Object.keys(SIZES).forEach(function (k) {
            if (SIZES[k].id !== v.id) return;
            PRICE[k] = Math.round(v.price / 100);
            var c = v.compare_at_price ? Math.round(v.compare_at_price / 100) : 0;
            WAS[k] = c > PRICE[k] ? c : 0;
            SIZES[k].available = !!v.available;
          });
        });
        paintPrices();
        recalc();
      }).catch(function () {});
    })();

    sizeBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        size = b.getAttribute('data-size');
        recalc();
      });
    });

    if (goBtn) {
      goBtn.addEventListener('click', function () {
        var s = SIZES[size];
        if (busy || !s || !s.available || !s.id) return;
        busy = true;
        recalc();
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: s.id, quantity: 1 }] })
        }).then(function (r) {
          if (!r.ok) throw new Error('cart add ' + r.status);
          window.location.href = '/cart';
        }).catch(function () {
          busy = false;
          recalc();
          window.location.href = fallbackHref;
        });
      });
    }

    /* Any hero tile or size card can select a size and scroll to the chooser,
       so "I want the 41.5" from anywhere on the page lands on it already
       chosen. Scoped to CTAs OUTSIDE the panel: the seg buttons carry the
       same attribute and must keep their own handler. */
    Array.prototype.forEach.call(root.querySelectorAll('[data-size]'), function (a) {
      if (panel.contains(a)) return;
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var k = a.getAttribute('data-size');
        if (SIZES[k]) size = k;
        recalc();
        var g = GEO.map.choose;
        if (g) glideTo(g.top, 0);
        panel.classList.add('is-flash');
        setTimeout(function () { panel.classList.remove('is-flash'); }, 1200);
      });
    });

    /* Seed PRICE and WAS from what liquid already rendered, in case a button
       lost its data attributes. Without this a failed .js fetch could leave
       every compare-at hidden for good, silently dropping strike-through
       prices the server had already proven were real. */
    (function seedFromServerRender() {
      var read = function (el) {
        var n = parseInt((el.textContent || '').replace(/[^0-9]/g, ''), 10);
        return isNaN(n) ? 0 : n;
      };
      Array.prototype.forEach.call(root.querySelectorAll('[data-live-price]'), function (el) {
        var k = el.getAttribute('data-live-price'), v = read(el);
        if (v > 0 && !PRICE[k]) PRICE[k] = v;
      });
      Array.prototype.forEach.call(root.querySelectorAll('[data-live-was]'), function (el) {
        var k = el.getAttribute('data-live-was'), v = read(el);
        if (v > 0 && !WAS[k]) WAS[k] = v;
      });
    })();

    paintPrices();
    recalc();
  })();

  var hasGsap = typeof window.gsap !== 'undefined' && typeof window.ScrollTrigger !== 'undefined';

  if (hasGsap) {
    var gsap = window.gsap;
    gsap.registerPlugin(window.ScrollTrigger);

    if (journey) {
      window.ScrollTrigger.create({
        trigger: journey.section,
        start: 'top bottom',
        end: 'bottom bottom',
        onUpdate: function () { journey.update(); },
        onLeave: function () { journey.update(); },
        onLeaveBack: function () { journey.update(); }
      });
      journey.update();
    }

    if (header) {
      window.ScrollTrigger.create({
        start: 80,
        end: 'max',
        onEnter: function () { header.classList.add('is-scrolled'); },
        onLeaveBack: function () { header.classList.remove('is-scrolled'); }
      });
    }

    /* Journey rail: the pinned-stage zones are driven from journey.update()
       (they are chapters, not sections, so they have no trigger of their
       own); every real section keeps its own trigger. */
    var STAGE_ZONES = ['story', 'detail'];
    var railLinks = Array.prototype.slice.call(root.querySelectorAll('[data-rail]'));
    railLinks.forEach(function (link) {
      if (STAGE_ZONES.indexOf(link.dataset.rail) !== -1) return;
      var section = root.querySelector('[data-agbe="' + link.dataset.rail + '"]');
      if (!section) return;
      window.ScrollTrigger.create({
        trigger: section,
        start: 'top center',
        end: 'bottom center',
        onToggle: function (self) {
          if (self.isActive) {
            railLinks.forEach(function (l) {
              l.classList.toggle('is-current', l === link);
              if (l === link) l.setAttribute('aria-current', 'true');
              else l.removeAttribute('aria-current');
            });
          }
        }
      });
    });

    gsap.matchMedia().add('(prefers-reduced-motion: no-preference)', function () {
      var heroSection = root.querySelector('[data-agbe="hero"]');
      var heroPhoto = root.querySelector('[data-hero-photo]');
      var heroCopy = root.querySelector('[data-hero-copy]');
      var heroDip = root.querySelector('[data-hero-dip]');
      if (heroSection && heroPhoto) {
        gsap.timeline({
          scrollTrigger: { trigger: heroSection, start: 'top top', end: 'bottom bottom', scrub: 0.4 },
          defaults: { ease: 'none' }
        })
          .to(heroPhoto, { scale: 1.12, yPercent: -4, transformOrigin: '62% 45%', duration: 1 }, 0)
          .to(heroCopy, { autoAlpha: 0, y: -36, duration: 0.35 }, 0.3)
          .to(heroDip, { opacity: 1, duration: 0.3 }, 0.45);
      }

      var cards = root.querySelectorAll('[data-card]');
      if (cards.length) {
        gsap.from(cards, {
          y: 36,
          autoAlpha: 0,
          duration: 0.7,
          ease: 'power2.out',
          stagger: 0.12,
          scrollTrigger: { trigger: root.querySelector('.agbe-cards'), start: 'top 80%', once: true }
        });
      }

      /* The data sheet lives behind a click-to-expand fold now - the
         scrubbed entrance retired with the always-visible table. */

      return function () {};
    });
    return;
  }

  /* --- Fallback without GSAP: films, captions, chapters, seq bar, header --- */
  var ticking = false;
  function update() {
    if (journey) journey.update();
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 80);
  }
  addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { update(); ticking = false; });
  }, { passive: true });
  addEventListener('resize', update);
  addEventListener('load', function () {
    var warmAll = function () {
      if (journey) journey.films.forEach(function (f) { if (f) f.warm(); });
    };
    if ('requestIdleCallback' in window) requestIdleCallback(warmAll);
    else setTimeout(warmAll, 200);
  });
  update();
})();
